import React from "react";
import { useSelector } from "react-redux";
import { AccountServiceErrorCode } from "@sportal/api";

import {
  getAccount as loadAccount,
  isAccountCreationFailed,
} from "../../store/account";
import { getAccount, getConfig } from "../../store/root.selectors";
import { isSuccess, useLoadableSlice } from "../../store/shared";
import ErrorPage, {
  ErrorPageType,
  shouldShowErrorPage,
} from "../../pages/errorPage/ErrorPage";
import { Logout } from "../../pages/login/Logout";

export const withAccountGuard = (Component) => () => {
  const account = useLoadableSlice(loadAccount(), getAccount);
  const accountCreationFailed = useSelector(isAccountCreationFailed);
  const { showErrorPageBeforeAutoLogout } = useSelector(getConfig);

  if (account === null) {
    return null;
  }

  if (isSuccess(account)) {
    return <Component />;
  }

  if (showErrorPageBeforeAutoLogout && accountCreationFailed) {
    return <ErrorPage type={ErrorPageType.AccountError} />;
  }

  if (shouldShowErrorPage(account, AccountServiceErrorCode.GENERIC)) {
    return <ErrorPage />;
  }

  return <Logout />;
};
